export default __webpack_public_path__ + "static/media/2282.c3ea8730.png";